import { render } from "./fcu.vue?vue&type=template&id=0172673e&scoped=true"
const script = {}

import "./fcu.vue?vue&type=style&index=0&id=0172673e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0172673e"

export default script